import OtherServicesWidget from "../components/OtherServicesWidget/OtherServicesWidget";
import ServiceText from "../components/ServiceText/ServiceText";
import styles from "./styles/Atik.module.css";
import atikTransferiVideo from "../videos/atiktransferi.mp4"
import { useTranslation } from 'react-i18next';

export default function Atik () {
    const { t } = useTranslation();
    return (
      <main>
        <div className={styles.mainLandingContainer}>
          <div className={styles.landingContainer}>
            <div className={styles.landingCoverContainer}>
              <h1 className={styles.landingHeader}>{t('services.transferTitle')}</h1>
            </div>
          </div>
        </div>
        <ServiceText 
            serviceHeader={t('services.transferTitle')} 
            serviceText={t('services.transferText')}
        />
        <div className={styles.serviceVideoContainer}>
          <video className={styles.serviceVideo} controls autoPlay>
            <source src={atikTransferiVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <OtherServicesWidget />
      </main>
    );
  }